// extracted by mini-css-extract-plugin
module.exports = {"contactMoment":"AppSideBar_contactMoment__JS1BN","contactMomentMain":"AppSideBar_contactMomentMain__2xR1P"};